module.exports = __webpack_public_path__ + "img/failedIcon.9c126e1b.svg";